<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="filteredEstablecimientoList.length !== 0 ? 250 : 50"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="indigo" dark v-bind="attrs" v-on="on">
          Establecimientos <v-icon right>fa-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content
              v-if="filteredEstablecimientoList.length !== 0"
            >
              <v-list-item-title
                >{{ establecimiento.nombre
                }}<v-icon
                  right
                  small
                  color="brown"
                  v-if="hasCategoriaGanaderia"
                  >{{ cowIcon }}</v-icon
                >
                <v-icon
                  right
                  small
                  color="primary"
                  v-if="hasCategoriaAgricultura"
                  >fa-seedling</v-icon
                ></v-list-item-title
              >
            </v-list-item-content>

            <!-- <v-list-item-action> -->
            <v-btn small color="primary" @click.stop="abrirDialog"
              >Crear establecimiento
            </v-btn>
            <!-- </v-list-item-action> -->
          </v-list-item>
        </v-list>

        <v-divider v-if="filteredEstablecimientoList.length !== 0"></v-divider>
        <v-subheader>Más establecimientos</v-subheader>
        <v-list class="py-0">
          <template v-for="(est, e) in filteredEstablecimientoList">
            <v-list-item-group :key="e">
              <v-list-item @click="handleElegirEstablecimiento(est)">
                <v-list-item-title
                  >{{ est.nombre }}
                  <template v-for="grupo in est.grupoExplotacionList">
                    <v-icon
                      class="ml-2"
                      small
                      color="brown"
                      :key="`${grupo.idGrupoExplotacion}${est.idEstablecimiento}`"
                      v-if="grupo.categoria === 2"
                      >{{ cowIcon }}</v-icon
                    >
                    <v-icon
                      class="ml-2"
                      small
                      color="primary"
                      :key="`${grupo.idGrupoExplotacion}${est.idEstablecimiento}`"
                      v-else
                      >fa-seedling</v-icon
                    >
                    <span
                      :key="`${grupo.idGrupoExplotacion}${grupo.nombre}`"
                      class="grey--text"
                    ></span>
                  </template>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </template>

          <v-list-item v-if="filteredEstablecimientoList.length === 0">
            <v-list-item-content>
              <v-list-item-subtitle class="pl-5"
                >No se encontraron más establecimientos</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <!-- Dialog for adding and editing establecimientos -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <fh-crud-establecimientos
        :formTitle="formTitle"
        :editData="editData"
        v-on:terminated="closeDialog"
      >
      </fh-crud-establecimientos>
    </v-dialog>
  </div>
</template>

<script>
import FhCrudEstablecimientos from "@/components/app/FhCrudEstablecimientos.vue";
import { mdiCow } from "@mdi/js";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "FhEstablecimientoMenu",
  components: {
    FhCrudEstablecimientos,
  },
  data: () => ({
    cowIcon: mdiCow,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    editData: null,
    dialog: false,
    formTitle: "Agregar un Establecimiento",
  }),
  computed: {
    ...mapState("establecimientos", [
      "establecimiento",
      "establecimientosList",
    ]),
    ...mapState("agricultor", ["listaGrupoExplotacion", "agricultor"]),
    ...mapGetters("establecimientos", [
      "isEstablecimientoSet",
      "hasCategoriaAgricultura",
      "hasCategoriaGanaderia",
      "filteredEstablecimientoList",
      "ganaderiaExplotacion",
      "currentCategoria",
    ]),
  },
  methods: {
    ...mapActions("agricultor", ["fetchListaGrupoExplotacion"]),
    ...mapActions("zonas", ["fetchListaZona"]),
    ...mapActions("snackbar", ["showSnackbar"]),
    ...mapActions("establecimientos", [
      "fetchEstablecimientosList",
      "clearEstablecimiento",
      "clearEstablecimientoList",
      "setEstablecimiento",
    ]),
    async closeDialog() {
      this.dialog = false;
      await this.fetchEstablecimientosList(this.agricultor.idAgricultor);
    },
    async abrirDialog() {
      await this.fetchListaGrupoExplotacion(this.agricultor.idAgricultor);
      await this.fetchListaZona();

      if (
        this.listaGrupoExplotacion.listaAgro.length === 0 &&
        this.listaGrupoExplotacion.listaGanaderia.length === 0 &&
        this.listaGrupoExplotacion.listaParticular.length === 0
      ) {
        this.showSnackbar([
          "Usted no tiene permisos para agregar nuevos establecimientos a este agricultor",
        ]);
        return;
      }

      this.dialog = true;
    },
    async handleElegirEstablecimiento(establecimiento) {
      this.menu = false;
      this.$emit("changeEstablecimiento", establecimiento);
    },
  },
};
</script>